setInterval(function () {
    if (jQuery(".logo-sec .owl-carousel").length > 0) {
        if (!jQuery(".logo-sec .owl-carousel").hasClass("owl_carousel_initialized1")) {
            jQuery(".logo-sec .owl-carousel").owlCarousel({
                loop: false,
                margin: 10,
                nav: true,
                responsive: {
                    0: {
                        items: 2,
                    },
                    600: {
                        items: 2,
                    },
                    1000: {
                        items: 6,
                    },
                },
            });
            jQuery(".logo-sec .owl-carousel").addClass("owl_carousel_initialized1");
        }
    }
}, 1000);

setInterval(function () {
    if (jQuery(".product-sec  .owl-carousel").length > 0) {
        if (!jQuery(".product-sec  .owl-carousel").hasClass("owl_carousel_initialized1")) {
            jQuery(".product-sec  .owl-carousel").owlCarousel({
                loop: false,
                margin: 10,
                nav: true,
                responsive: {
                    0: {
                        items: 2,
                    },
                    600: {
                        items: 2,
                    },
                    1000: {
                        items: 6,
                    },
                },
            });
            jQuery(".product-sec  .owl-carousel").addClass("owl_carousel_initialized1");
        }
    }
}, 1000);

setInterval(function () {
    if (jQuery(".products_slider_box .owl-carousel").length > 0) {
        if (!jQuery(".products_slider_box .owl-carousel").hasClass("owl_carousel_initialized1")) {
            jQuery(".products_slider_box .owl-carousel").owlCarousel({
                loop: false,
                margin: 10,
                nav: true,
                responsive: {
                    0: {
                        items: 2,
                    },
                    600: {
                        items: 2,
                    },
                    1000: {
                        items: 2,
                    },
                },
            });
            jQuery(".products_slider_box .owl-carousel").addClass("owl_carousel_initialized1");
        }
    }
}, 1000);

setInterval(function () {
    if (jQuery(".products-slider-box .owl-carousel").length > 0) {
        if (!jQuery(".products-slider-box .owl-carousel").hasClass("owl_carousel_initialized1")) {
            jQuery(".products-slider-box .owl-carousel").owlCarousel({
                loop: false,
                margin: 10,
                nav: true,
                responsive: {
                    0: {
                        items: 2,
                    },
                    600: {
                        items: 2,
                    },
                    1000: {
                        items: 2,
                    },
                },
            });
            jQuery(".products-slider-box .owl-carousel").addClass("owl_carousel_initialized1");
        }
    }
}, 1000);
$(document).ready(function () {
    let slideIndex = 1;
    showSlides(slideIndex);

    function plusSlides(n) {
        showSlides((slideIndex += n));
    }

    function currentSlide(n) {
        showSlides((slideIndex = n));
    }

    function showSlides(n) {
        let i;
        let slides = document.getElementsByClassName("mySlides");
        let dots = document.getElementsByClassName("dot");
        if (n > slides.length) {
            slideIndex = 1;
        }
        if (n < 1) {
            slideIndex = slides.length;
        }
        for (i = 0; i < slides.length; i++) {
            slides[i].style.display = "none";
        }
        for (i = 0; i < dots.length; i++) {
            dots[i].className = dots[i].className.replace(" active", "");
        }
        slides[slideIndex - 1].style.display = "block";
        dots[slideIndex - 1].className += " active";
    }

    function slider(flag, num) {
        var current = $(".item.current"),
            next,
            index;
        if (!flag) {
            next = current.is(":last-child") ? $(".item").first() : current.next();
            index = next.index();
        } else if (flag === "dot") {
            next = $(".item").eq(num);
            index = num;
        } else {
            next = current.is(":first-child") ? $(".item").last() : current.prev();
            index = next.index();
        }
        next.addClass("current");
        current.removeClass("current");
        $(".dot").eq(index).addClass("current").siblings().removeClass("current");
    }
    var setSlider = setInterval(slider, 4000);

    $(".button").on("click", function () {
        clearInterval(setSlider);
        var flag = $(this).is(".prev") ? true : false;
        slider(flag);
        setSlider = setInterval(slider, 4000);
    });

    $(".dot").on("click", function () {
        if ($(this).is(".current")) return;
        clearInterval(setSlider);
        var num = $(this).index();
        slider("dot", num);
        setSlider = setInterval(slider, 4000);
    });

    $('[data-id="model"]').on("click", function () {
        var thisModel = $(this).data("target");
        $(thisModel).show();
        $(thisModel)
            .find('[data-close="model"]')
            .click(function () {
                $(thisModel).hide();
            });
        $(window).click(function (event) {
            if ("#" + event.target.id == thisModel) {
                $(thisModel).hide();
            }
        });
    });
});
document.addEventListener("DOMContentLoaded", function () {
    var accordionHeaders = document.querySelectorAll(".accordion-head");
    var accordionBodies = document.querySelectorAll(".accordion-body");

    // Open the first accordion body by default
    if (accordionBodies.length > 0) {
        accordionBodies[0].style.maxHeight = accordionBodies[0].scrollHeight + "px";
        accordionBodies[0].style.padding = "10px";
    }

    accordionHeaders.forEach(function (header) {
        header.addEventListener("click", function () {
            var body = header.nextElementSibling;
            var isVisible = body.style.maxHeight && body.style.maxHeight !== "0px";

            accordionBodies.forEach(function (b) {
                b.style.maxHeight = "0";
                b.style.padding = "0";
            });

            if (!isVisible) {
                body.style.maxHeight = body.scrollHeight + "px";
                body.style.padding = "0";
                header.scrollIntoView({ behavior: "smooth" });
            }
        });
    });
});
jQuery(document).ready(function () {
    jQuery(".testimonial-slider").owlCarousel({
        loop: false,
        margin: 10,
        nav: true,
        items: 1,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        center: true,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 1,
            },
            1000: {
                items: 3,
            },
        },
    });
});
jQuery(document).ready(function () {
    jQuery(".logoAlign .toggle").click(function () {
        jQuery(".custom_menu_drawer").toggleClass("open-menu-drawer");
    });
    jQuery("h1.custom_menu_drawer-controls svg.icon.icon-close").click(function () {
        jQuery(".custom_menu_drawer").toggleClass("open-menu-drawer");
    });
});

jQuery(document).ready(function () {
    jQuery(".float").click(function () {
        jQuery(this).toggleClass("currentOpen");
        jQuery(".product__description.rte.quick-add-hidden").toggle();
        // Get the SVG element
        var svgIcon = jQuery(this).find("svg");
        if (svgIcon.hasClass("rotated")) {
            svgIcon.css("transform", "rotate(0deg)");
            svgIcon.removeClass("rotated");
        } else {
            svgIcon.css("transform", "rotate(180deg)");
            svgIcon.addClass("rotated");
        }
    });
});
$(document).ready(function () {
    $(".search_query")
        .autocomplete({
            source: function (request, response) {
                $.ajax({
                    url: "/search/suggest.json?q=" + request.term,
                    dataType: "json",
                    success: function (data) {
                        console.log("API response:", data);
                        response(
                            $.map(data.resources.results.products, function (item) {
                                console.log("Item data:", item);
                                return {
                                    label: item.title,
                                    value: item.title,
                                    url: item.url,
                                    image: item.image ? item.image.src : "",
                                };
                            })
                        );
                    },
                    error: function (xhr, status, error) {
                        console.error("AJAX Error:", status, error);
                    },
                });
            },
            select: function (event, ui) {
                window.location.href = ui.item.url;
                return false;
            },
            minLength: 2,
            delay: 300,
            open: function () {
                $(".ui-autocomplete").css("z-index", 1000);
            },
        })
        .data("ui-autocomplete")._renderItem = function (ul, item) {
        console.log("Rendering item:", item);

        var $li = $("<li>").append(
            "<div class='autocomplete-item'>" +
                "<img src='" +
                (item.image || "placeholder.jpg") +
                "' alt='" +
                item.label +
                "' class='autocomplete-thumbnail' style='width:50px;height:auto;margin-right:10px;'/>" +
                "<span>" +
                item.label +
                "</span>" +
                "</div>"
        );

        return $li.appendTo(ul);
    };
});
const popupBtn = document.getElementById("OpenModal");
const popup = document.getElementById("Popup");
const openPopup = () => {
    if (popup.style.display === "none") {
        popup.style.display = "block";
    } else {
        popup.style.display = "none";
    }
};
const closeModal = () => {
    popup.style.display = "none";
};
jQuery(document).ready(function () {
    if (window.innerWidth <= 992) {
        jQuery(".owl-carousel.catogarySlider").owlCarousel({
            items: 4,
            loop: true,
            margin: 10,
            nav: true,
            dots: true,
            responsive: {
                0: {
                    items: 1.5,
                },
                600: {
                    items: 2,
                },
                1000: {
                    items: 4,
                },
            },
        });
    } else {
        jQuery(".owl-carousel.catogarySlider").owlCarousel({
            items: 4,
            loop: false,
            margin: 10,
            nav: true,
            dots: true,
            responsive: {
                0: {
                    items: 1,
                },
                600: {
                    items: 2,
                },
                1000: {
                    items: 4,
                },
            },
        });
    }
});

jQuery(document).ready(function () {
    if (window.innerWidth <= 992) {
        jQuery(".owl-carousel.ShippingSlider").owlCarousel({
            items: 6,
            loop: false,
            margin: 10,
            nav: true,
            dots: true,
            responsive: {
                0: {
                    items: 1,
                },
                600: {
                    items: 4,
                },
                1000: {
                    items: 4,
                },
            },
        });
    } else {
    }
});

jQuery(".myOwlCarousel").owlCarousel({
    items: 3,
    loop: false,
    margin: 10,
    autoplay: true,
    nav: true,
    dots: true,
    responsive: {
        0: {
            items: 1,
        },
        501: {
            items: 1,
        },
        769: {
            items: 2,
            margin: 5,
        },
        1025: {
            items: 3,
            margin: 5,
        },
    },
    onInitialized: function () {
        setTimeout(setEqualHeight_myOwlCarousel, 100); // Delay for ensuring content is fully loaded
    },
    onResized: function () {
        setTimeout(setEqualHeight_myOwlCarousel, 100); // Recalculate on resize
    },
});

function setEqualHeight_myOwlCarousel() {
    var maxHeight = 0;
    var items = jQuery(".myOwlCarousel .owl-item");

    var itemsInner = jQuery(".myOwlCarousel .owl-item .responsive-container-block.content");

    items.css("height", "auto"); // Reset height to calculate again

    items.each(function () {
        var thisHeight = jQuery(this).outerHeight();
        if (thisHeight > maxHeight) {
            maxHeight = thisHeight;
        }
    });

    items.css("height", maxHeight + "px"); // Set the height to the tallest element
    itemsInner.css("height", maxHeight + "px");
}

// Trigger equal height adjustment on window resize
jQuery(window).on("resize", function () {
    setTimeout(setEqualHeight_myOwlCarousel, 100);
});
$(document).ready(function () {
    $(".popup_on1").click(function () {
        $("#Popup1").toggle(1000);
    });
});
document.addEventListener("DOMContentLoaded", function () {
    var openPopupButton = document.getElementById("OpenModal");
    var mobiSerch = document.querySelector(".mobiSerch");
    var closeButton = document.querySelector(".iconBoxed .search-modal__close-buttonbox");

    var openPopupButton1 = document.getElementById("OpenModal1");

    function openPopups() {
        mobiSerch.classList.add("show");
        const detailsElement = document.querySelector("details");
        if (detailsElement) {
            detailsElement.setAttribute("open", "true");
        }
    }

    function closePopups() {
        mobiSerch.classList.remove("show");
        const detailsElement = document.querySelector("details");
        if (detailsElement) {
            detailsElement.removeAttribute("open");
        }
    }

    openPopupButton.addEventListener("click", openPopups);
    openPopupButton1.addEventListener("click", openPopups);
    closeButton.addEventListener("click", closePopups);

    const closeButton_modal = document.querySelector(".modal__close-button.link");
    if (closeButton_modal) {
        closeButton_modal.addEventListener("click", function () {
            closePopups();
        });
    }
});

window.addEventListener("scroll", function () {
    var header = document.querySelector("header.mainHeader");
    if (window.scrollY > 50 && window.innerWidth <= 768) {
        header.classList.add("fixed");
    } else if (window.scrollY <= 50 && window.innerWidth <= 768) {
        header.classList.remove("fixed");
    }
});

window.addEventListener("scroll", function () {
    var header = document.querySelector("header.mainHeader");
    var mainContent = document.getElementById("MainContent");
    var scrollY = window.scrollY;
    var windowWidth = window.innerWidth;

    if (scrollY > 50 && windowWidth >= 768) {
        if (!header.classList.contains("fixed")) {
            header.classList.add("fixed");
            mainContent.style.marginTop = header.offsetHeight + "px";
        }
    } else if (scrollY <= 50 && windowWidth >= 768) {
        if (header.classList.contains("fixed")) {
            header.classList.remove("fixed");
            mainContent.style.marginTop = "0";
        }
    }
});

function toggleMobileCart() {
    jQuery(".drawer.animate").addClass("active");
    jQuery("body").addClass("overflow-hidden");
}

document.addEventListener("DOMContentLoaded", () => {
    const firstTab = document.querySelector(".tabName");
    const firstDescription = firstTab.nextElementSibling;
    const firstIcon = firstTab.querySelector(".arrow-icon");

    firstDescription.style.maxHeight = firstDescription.scrollHeight + "px";
    firstDescription.classList.add("expanded");
    firstIcon.classList.remove("down");
    firstIcon.classList.add("up");
    document.querySelectorAll(".tabName").forEach((tab) => {
        tab.addEventListener("click", () => {
            const description = tab.nextElementSibling;
            const icon = tab.querySelector(".arrow-icon");
            document.querySelectorAll(".product__description").forEach((desc) => {
                if (desc !== description) {
                    desc.style.maxHeight = null;
                    desc.classList.remove("expanded");
                    desc.previousElementSibling.querySelector(".arrow-icon").classList.remove("up");
                    desc.previousElementSibling.querySelector(".arrow-icon").classList.add("down");
                }
            });
            if (description.classList.contains("expanded")) {
                description.style.maxHeight = null;
                description.classList.remove("expanded");
                icon.classList.remove("up");
                icon.classList.add("down");
            } else {
                description.style.maxHeight = description.scrollHeight + "px";
                description.classList.add("expanded");
                icon.classList.remove("down");
                icon.classList.add("up");
                setTimeout(() => {
                    const tabPosition = tab.getBoundingClientRect();
                    const footerPosition = document.querySelector("footer").getBoundingClientRect();
                    const viewportHeight = window.innerHeight;

                    if (tabPosition.top < 0 || tabPosition.bottom > viewportHeight) {
                        window.scrollBy({
                            top: tabPosition.top - 150,
                            behavior: "smooth",
                        });
                    }
                    const expandedBottom = tabPosition.top + description.scrollHeight;
                    if (expandedBottom > footerPosition.top) {
                        window.scrollTo({
                            top: footerPosition.top - viewportHeight,
                            behavior: "smooth",
                        });
                    }
                }, 300);
            }
        });
    });
});
document.addEventListener("DOMContentLoaded", function () {
    const faqItems = document.querySelectorAll(".faq-item");

    faqItems.forEach((item) => {
        const head = item.querySelector(".faq-head");
        const body = item.querySelector(".faq-body");

        head.addEventListener("click", function () {
            const isVisible = body.style.maxHeight;
            faqItems.forEach((i) => {
                i.querySelector(".faq-body").style.maxHeight = null;
                i.classList.remove("active");
            });
            if (!isVisible) {
                body.style.maxHeight = body.scrollHeight + "px";
                item.classList.add("active");
            } else {
                body.style.maxHeight = null;
                item.classList.remove("active");
            }
        });
    });
});
window.addEventListener("scroll", function () {
    const goodstApp = document.querySelector("#goodst-app");
    const footer = document.querySelector("footer");
    const cardImages = document.querySelector(".card_images"); // Selects the element with the class "card_images"
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const footerOffsetTop = footer.offsetTop;
    const cardImagesOffsetTop = cardImages.offsetTop; // Get the top position of the "card_images" element
    const isMobile = window.innerWidth <= 768;

    // Show or hide the element based on scroll position
    if (scrollPosition > 700) {
        goodstApp.classList.add("fixedapp");
        goodstApp.style.display = "block";
    } else {
        goodstApp.classList.remove("fixedapp");
        goodstApp.style.display = "none";
    }

    // Display block when scrolling reaches the "card_images" section
    if (scrollPosition + windowHeight > cardImagesOffsetTop) {
        goodstApp.style.display = "block"; // Show the element
    }

    // Logic for the footer when scroll reaches the bottom of the page
    if (!isMobile && scrollPosition + windowHeight >= footerOffsetTop) {
        goodstApp.classList.remove("fixedapp");
    }

    // Mobile-specific scroll logic
    if (isMobile && scrollPosition > 100) {
        goodstApp.classList.add("fixedapp");
    } else if (isMobile && scrollPosition <= 100) {
        goodstApp.classList.remove("fixedapp");
    }
});
document.addEventListener("DOMContentLoaded", function () {
    document.querySelector('#footerfixedAddtoCart button[name="minus"]').addEventListener("click", function () {
        document.querySelector('product-info button[name="minus"]').click(); // Trigger click on the product-info button
    });

    // Synchronizing the plus button
    document.querySelector('#footerfixedAddtoCart button[name="plus"]').addEventListener("click", function () {
        document.querySelector('product-info button[name="plus"]').click(); // Trigger click on the product-info button
    });

    document.querySelector("#ProductSubmitButton_footer").addEventListener("click", function () {
        document.querySelector('product-info .product-form__buttons button[name="add"]').click(); // Trigger click on the product-info button
    });
});
document.addEventListener("DOMContentLoaded", function () {
    var tooltipLinks = document.querySelectorAll(".tooltip-link");

    tooltipLinks.forEach(function (link) {
        link.addEventListener("mouseover", function (event) {
            // Get the title attribute
            var title = this.getAttribute("title");
            // Store the title in a data attribute and remove the title to prevent default browser behavior
            this.setAttribute("data-title", title);
            this.removeAttribute("title");

            // Create the tooltip element
            var tooltip = document.createElement("div");
            tooltip.className = "custom-tooltip";
            tooltip.textContent = title;
            document.body.appendChild(tooltip);

            // Position the tooltip
            var tooltipX = event.pageX + 5;
            var tooltipY = event.pageY + 5;
            tooltip.style.left = tooltipX + "px";
            tooltip.style.top = tooltipY + "px";
            tooltip.style.display = "block";
        });

        link.addEventListener("mousemove", function (event) {
            var tooltip = document.querySelector(".custom-tooltip");
            // Update tooltip position as the mouse moves
            var tooltipX = event.pageX + 5;
            var tooltipY = event.pageY + 5;
            tooltip.style.left = tooltipX + "px";
            tooltip.style.top = tooltipY + "px";
        });

        link.addEventListener("mouseout", function () {
            // Restore the title attribute and remove the tooltip
            var title = this.getAttribute("data-title");
            this.setAttribute("title", title);

            var tooltip = document.querySelector(".custom-tooltip");
            if (tooltip) {
                tooltip.remove();
            }
        });
    });
});


document.addEventListener("DOMContentLoaded", () => {
  const lazyElements = document.querySelectorAll('img[data-src], iframe[data-src]');

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          el.src = el.dataset.src;
          el.onload = () => el.removeAttribute('data-src');
          observer.unobserve(el);
        }
      });
    });

    lazyElements.forEach(el => observer.observe(el));
  } else {
    // Fallback for older browsers
    lazyElements.forEach(el => {
      el.src = el.dataset.src;
      el.onload = () => el.removeAttribute('data-src');
    });
  }
});

 $(document).ready(function () {
   setTimeout(function () {
      $(".lazy-addimg").each(function () {
        var dataSrc = $(this).attr("data-srcd");
        $(this).attr("src", dataSrc);
      });
      $(".product_imgappend").each(function () {
        var dataSrcpd = $(this).attr("data-full-size-image-url");
        $(this).attr("src", dataSrcpd);
      });
        $(".shopbycatappend").each(function () {
        var dataSrcbycat = $(this).attr("data-srcshop");
        $(this).attr("src", dataSrcbycat);
      });
       $(".banner1append").each(function () {
      var banner1 = $(this).attr("data-banner1srcd");
      $(this).attr("src", banner1);
    });
     $(".banner2append").each(function () {
      var banner2 = $(this).attr("data-banner2srcd");
      $(this).attr("src", banner2);
    });
      }, 2000);
  });

